module.exports = __webpack_public_path__ + "img/haus.c7b02f39.jpg";